var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { BrowserNavigation } from 'navi';
import { NaviContext } from './NaviContext';
var NaviProvider = /** @class */ (function (_super) {
    __extends(NaviProvider, _super);
    function NaviProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.handleNavigationSnapshot = function (route) {
            if (route.type !== 'busy') {
                _this.setState({
                    steadyRoute: route,
                    busyRoute: undefined,
                });
            }
            else {
                _this.setState({
                    busyRoute: route,
                });
            }
        };
        _this.handleError = function (error) {
            throw error;
        };
        _this.state = {};
        return _this;
    }
    NaviProvider.getDerivedStateFromProps = function (props, state) {
        if (state.navigation !== props.navigation) {
            var route = props.navigation.getCurrentValue();
            return ((route.type === 'busy')
                ? { steadyRoute: state.steadyRoute, busyRoute: route, navigation: props.navigation }
                : { steadyRoute: route, busyRoute: undefined, navigation: props.navigation });
        }
        return null;
    };
    NaviProvider.prototype.render = function () {
        var context = this.state;
        var result = (React.createElement(NaviContext.Provider, { value: context }, this.props.children));
        // If <Suspense> is supported and the app is being rendered in a browser,
        // then wrap the app with a <Suspense> with an empty fallback, so that
        // the fallback doesn't need to be provided manually.
        var Suspense = React.Suspense;
        if (Suspense) {
            var fallback = this.props.fallback;
            if (!('fallback' in this.props) && this.props.navigation instanceof BrowserNavigation) {
                fallback = null;
            }
            if (fallback !== undefined) {
                result = React.createElement(Suspense, { fallback: fallback }, result);
            }
        }
        else if (this.props.fallback !== undefined) {
            console.warn("You supplied a \"fallback\" prop to your <NaviProvider>, but the version of React that you're using doesn't support Suspense. To use the \"fallback\" prop, upgrade to React 16.6 or later.");
        }
        return result;
    };
    NaviProvider.prototype.componentDidMount = function () {
        this.subscribe();
    };
    NaviProvider.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.navigation !== this.props.navigation) {
            this.unsubscribe();
            this.subscribe();
        }
    };
    NaviProvider.prototype.componentWillUnmount = function () {
        this.unsubscribe();
    };
    NaviProvider.prototype.subscribe = function () {
        if (!this.props.navigation) {
            throw new Error("A <NaviProvider> component must receive a \"navigation\" prop.");
        }
        this.subscription = this.props.navigation.subscribe(this.handleNavigationSnapshot, this.handleError);
    };
    NaviProvider.prototype.unsubscribe = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            delete this.subscription;
        }
    };
    return NaviProvider;
}(React.Component));
export { NaviProvider };
//# sourceMappingURL=NaviProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-navi/dist/es/NaviProvider.js
// module id = 72
// module chunks = 0